import React, { useState ,useEffect} from "react";
import { userinfo } from "../apis/services";
const Profile = ({ translate }) => {
  const [profile, setProfile] = useState({
    full_name: "",
    email: "",
  });
 const [user, setUser] = useState([]);


 const token = {
  token : localStorage.getItem("token")
} 
  
    useEffect(() => {
      userinfo(token).then((response) => { 
        setUser(response);
      }
      );
  }, []); 

  const updateProfile = (event) => {
    event.preventDefault();
    const full_name = event.target.full_name.value;
    const email = event.target.email.value;

    if (full_name && email) {
      setProfile({ full_name, email });
      alert(translate("profileUpdatedSuccessfully"));
    } else {
      alert(translate("pleaseFillAllFields"));
    }
  };

  return (
    <div className="content active">
      <h2>{translate("profile")}</h2>
      <div className="profile-section">
        <form onSubmit={updateProfile}>
          <input
            type="text"
            name="full_name"
            placeholder={user.full_name}
            defaultValue={user.full_name}
            required
          />
          <input
            type="email"
            name="email"
            placeholder={user.email}
            defaultValue={user.email}
            required
          />
          <button type="submit">{translate("updateProfile")}</button>
        </form>

        <h3>{translate("currentPlan")}</h3>
        <p>{translate("freePlan")}</p>

        <h3>{translate("walletAmount")}</h3>
        <p>1000.00</p>
      </div>
    </div>
  );
};

export default Profile;